// Module
var code = `<template>
  <require from="./dimension-over-time-widget.scss"></require>

  <div class="dimension-over-time-widget">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <!-- chart slightly sticks out from its boundaries, 96% makes sure there's no scroll -->
    <div show.bind="!loading && !error" class="dimension-over-time-widget__chart" style="height: 96%" ref="chart">
    </div>
    <div if.bind="legend" class="dimension-over-time-widget__legend dimension-over-time-widget__legend-\${id}" ref="legendDiv">
      <style>
        .dimension-over-time-widget__legend-\${id} .dimension-over-time-widget__data,
        .dimension-over-time-widget__legend-\${id} .dimension-over-time-widget__data a {
          font-family: \${font || 'var(--dyn-default-font-family)'};
          font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
          color: \${color | widgetTemplateColor:isInDashboard} !important;
        }

        .dimension-over-time-widget__legend-\${id} .dimension-over-time-widget__header {
          font-family: \${headerFont ? headerFont : 'var(--dyn-default-font-family)'};
          font-size: \${headerFontSize ? headerFontSize + 'px' : 'var(--dyn-default-font-size)'};
          color: \${headerColor | widgetTemplateColor:isInDashboard} !important;
        }
      </style>

      <div class="dimension-over-time-widget__header">
        <div class="dimension-over-time-widget__header__pl">P/L</div>
        <div class="dimension-over-time-widget__header__value">Value</div>
      </div>
      <div class="dimension-over-time-widget__data" repeat.for="d of legendData">
        <div class="dimension-over-time-widget__color" css="background-color: \${d.colour};"></div>
        <div class="dimension-over-time-widget__type">
          <a if.bind="isIgnite && groupBy === 2" href="index.html#/instruments-information?instrumentTypeId=\${d.groupId}&fontSize=\${fontSize}&headerFontSize=\${headerFontSize}&color=\${color}&headerColor=\${headerColor}">
            \${d.group}
          </a>
          <span else>\${d.group}</span>
        </div>
        <div class="dimension-over-time-widget__pl">\${d.profitLossClosingBalance | numericFormatter:'0,0'}</div>
        <div class="dimension-over-time-widget__value">\${d.estimatedValue | numericFormatter:'0,0'}</div>
        <div class="dimension-over-time-widget__pl-percent">
          \${d.profitLossPercent | numericFormatter:'0,0.0'}%
        </div>
        <div class="dimension-over-time-widget__value-percent">
          \${d.estimatedValuePercent | numericFormatter:'0,0.0'}%
        </div>
      </div>
    </div>

  </div>
  <message if.bind="error" icon="error" colour="mdc-theme--error" class="dimension-over-time-widget__error">
    \${error.message}</message>
  
</template>
`;
// Exports
export default code;